import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "answered-message" }
const _hoisted_2 = { class: "answered-message__body" }
const _hoisted_3 = { class: "answered-message__body-header" }
const _hoisted_4 = { class: "answered-message__body-header-name" }
const _hoisted_5 = { class: "answered-message__body-header-date" }
const _hoisted_6 = ["innerHTML"]

import {computed, ref} from "vue";
import ChatAttachedMessages from "@/components/main/chat-panel/modals/ChatAttachedMessages.vue";
import moment from "moment/moment";
import { AttachedMessage } from "@/store/chats";
import {applyChatMessagePlaceholders} from "@/utils/textHelpers";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatMessageAttached',
  props: {
    attachedMessage: {}
  },
  setup(__props: any) {

const props = __props

const $attachedMessages = ref<InstanceType<typeof ChatAttachedMessages> | null>(null);

const getDialogDate = (date: string) => moment(date).format("DD.MM.YYYY HH:mm");

const messageHtml = computed(() =>
	applyChatMessagePlaceholders(
		props.attachedMessage?.Text ?? '',
		props.attachedMessage?.Links,
		props.attachedMessage?.Bills
	).replaceAll('\n', '<br>')
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ChatAttachedMessages, {
      ref_key: "$attachedMessages",
      ref: $attachedMessages,
      title: _ctx.$t('chat_all_replies')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "answered-message__lable" }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(props.attachedMessage.Sender.Name), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(getDialogDate(props.attachedMessage.Date)), 1)
        ]),
        _createElementVNode("div", {
          class: "answered-message__body-text",
          innerHTML: messageHtml.value
        }, null, 8, _hoisted_6),
        (props.attachedMessage.AttachedMessagesCount)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "answered-message__body-more",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($attachedMessages.value.onOpen(props.attachedMessage.Id)), ["stop"]))
            }, _toDisplayString(_ctx.$t('chat_more_messages')), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})